import { motion } from 'framer-motion';
import React, { useState } from 'react';
import { IMAGE_BASE_URL } from '../config';
import Backdrop from './Backdrop';
import CarrouselPhotos from './CarrouselPhotos';
import './SpectacleView.css';

function SpectacleViewPhotos({ photos }) {
  const [photoSelected, setPhotoSelected] = useState(null);
  const [loadingImages, setLoadingImages] = useState({}); // Estado para manejar imágenes cargando

  const handleCloseBackdrop = () => {
    setPhotoSelected(null);
  };

  const handleImageLoad = (index) => {
    setLoadingImages((prev) => ({ ...prev, [index]: false }));
  };

  return (
    <div className="w-full max-w-[1200px] mx-0 sm:mx-auto flex flex-wrap justify-center">
      {photos &&
        photos.map((photo, index) => (
          <div key={photo} className="relative">
            {/* 📱 Versión para móviles */}
            <div
              className="sm:hidden border-b border-white/50 min-w-full min-h-full"
              style={{
                backgroundImage: `url(${IMAGE_BASE_URL}/images/miniatures/${photo})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
              }}
            >
              <img
                src={`${IMAGE_BASE_URL}/images/spectacles/${photo}`}
                onLoad={() => handleImageLoad(index)}
                className={`transition-opacity duration-500 ${
                  loadingImages[index] === false ? 'opacity-100' : 'opacity-0'
                }`}
                loading="lazy"
              />
            </div>

            {/* 🖥️ Versión para desktop */}
            <motion.div className="photo_galerie hidden sm:block relative overflow-hidden">
              <img
                onClick={() => setPhotoSelected(index)}
                src={`${IMAGE_BASE_URL}/images/miniatures/${photo}`}
                className="transition-opacity duration-500"
                loading="lazy"
              />
            </motion.div>
          </div>
        ))}

      {photoSelected !== null && (
        <Backdrop onClick={handleCloseBackdrop} hasCloser={true}>
          <CarrouselPhotos props={{ photos, currentPhoto: photoSelected }} />
        </Backdrop>
      )}
    </div>
  );
}

export default SpectacleViewPhotos;
